import styled from 'styled-components';

export const InputWrap = styled.div`
  position: relative;

  input {
    visibility: hidden;
  }
`;

export const ValueView = styled.div`
  position: absolute;
  bottom: 7px;
  left: 17px;
`;
